import { render, staticRenderFns } from "./NewLocationProvinceSelector.vue?vue&type=template&id=50b8d0c1"
import script from "./NewLocationProvinceSelector.vue?vue&type=script&lang=js"
export * from "./NewLocationProvinceSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports